<div *ngIf="showConfirm" class="overlay-confirm">

    <div class="confirm-container">

        <div class="confirm-container-header" *ngIf="_confirmService.confirmConfig.title">
            <span>{{ _confirmService.confirmConfig.title | translate}}</span>
        </div>

        <div class="confirm-container-section">
            <p>{{ _confirmService.confirmConfig.message | translate }}</p>

            <form *ngIf="_confirmService.confirmConfig.textInput" [formGroup]="inputForm">
                <input type="text" class="form-control fila-input" formControlName="text" (keydown.enter)="accept()">
            </form>

            <div class="confirm-footer">

                <button type="button" class="btn btn-secondary verde_con_efecto border_all"
                    [ngClass]="hasButtonAltOrCandel()" (click)="accept()" #focus [disabled]="inputForm.invalid">
                    <span
                        *ngIf="_confirmService.confirmConfig.textButtonAccept">{{ _confirmService.confirmConfig.textButtonAccept | translate}}</span>
                    <span
                        *ngIf="!_confirmService.confirmConfig.textButtonAccept">{{ 'labels.aceptar' | translate}}</span>
                </button>

                <button *ngIf="_confirmService.confirmConfig.onButtonAlternative" type="button" [ngClass]="hasButtonCancel()"
                        class="btn btn-secondary verde_con_efecto border_all" (click)="alternative()" [disabled]="inputForm.invalid">
                    <span *ngIf="_confirmService.confirmConfig.textButtonAlternative">
                        {{ _confirmService.confirmConfig.textButtonAlternative | translate}}
                    </span>
                    <span *ngIf="!_confirmService.confirmConfig.textButtonAlternative">
                        {{ 'labels.aceptar' | translate}}
                    </span>
                </button>

                <button *ngIf="_confirmService.confirmConfig.onButtonCancel" type="button"
                    class="btn btn-secondary rojo_con_efecto" (click)="cancel()">
                    <span
                        *ngIf="_confirmService.confirmConfig.textButtonCancel">{{ _confirmService.confirmConfig.textButtonCancel | translate}}</span>
                    <span
                        *ngIf="!_confirmService.confirmConfig.textButtonCancel">{{ 'labels.cancelar' | translate}}</span>

                </button>

            </div>

        </div>

    </div>

</div>
